import { useQuery } from '@tanstack/react-query';
import * as api from '../api/mail.api';

export const useFolders = (mailboxId) => {
  return useQuery({ queryKey: ['mail','folders',mailboxId], queryFn: () => api.mailboxFolders(mailboxId), enabled: !!mailboxId });
};
